import React from "react";
import { SsoPageContentMobile } from "../../blocks/ssoPage-content-mobile";
import { AdvantageList } from "../../blocks/advantage-list";
import { SSOPageContent } from "../../blocks/ssoPage-content";
import { CommonPageLink } from "../../blocks/common-page-link";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { ProductBanner } from "../../blocks/product-banner";
import { SSOPageContentSence } from "../../blocks/ssoPage-content-sence";
import { Footer } from "../../components/FooterV2";
import "./styles.less";
import { HomeTryOn } from "../../blocks/home-try-on";
import { VerifyPageContent } from "../../blocks/verifyPage-content";
import { VerifyPageSDK } from "../../blocks/verifyPage-sdk";
import { DatabasePageContent } from "../../blocks/databasePage-content";
import { DatabasePageSolutions } from "../../blocks/databasePage-solutions";
import { DatabaseTable } from "../../blocks/databasePage-table";
import { Helmet } from "react-helmet";

export const DatabasePage = () => {
  const bannerData = {
    title: "learn.databasePage.banner.title",
    subTitle: "learn.databasePage.banner.subtitle",
    bannerImg: {
      src: "//files.authing.co/authing-website/database-page-banner-new.png",
      alt: "authing employee-identity-manage",
    },
    bannerBG: {
      src: "//files.authing.co/authing-website/sso-banner-bg.png",
      alt: "authing",
    },
    hasButton: true,
    docLink:
      "https://docs.authing.cn/v2/guides/database-connection/overview.html",
  };
  const advantageData = [...Array(3)].map((item, index) => {
    return {
      label: `learn.databasePage.advantageData.${index}.label`,
      value: `learn.databasePage.advantageData.${index}.value`,
    };
  });
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.sso.title"),
      description: t("common.pageLink.sso.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/learn/sso",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  return (
    <div className="sso-page">
      <Helmet>
        <title>
          自定义数据库连接-简单自定义数据库连接池-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="light" />
      <ProductBanner {...bannerData} />
      <AdvantageList advantageData={advantageData} position="bottom" />
      <DatabasePageContent />
      <DatabasePageSolutions />
      <DatabaseTable />
      <CommonPageLink pagesLink={pagesLink} />
      <div className="ssoPage-homeTryOn-bg">
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
